import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import {Navbar, Nav, Container, Row, Col} from 'react-bootstrap';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Preloader from './components/Preloader';
import './App.css';
import config from "./config";

function App() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 100);
    }, []);

    return (
        <Router>
            {loading ? (
                <Preloader />
            ) : (
                <div className="App">
                    <header>
                        <Navbar bg="white" expand="lg" className="border-bottom border-success">
                            <Container>
                                <Navbar.Brand as={Link} to="/">{config.companyFullName}</Navbar.Brand>
                                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                                <Navbar.Collapse id="basic-navbar-nav">
                                    <Nav className="me-auto">
                                        <Nav.Link as={Link} to="/">Главная</Nav.Link>
                                        <Nav.Link as={Link} to="/projects">Проекты</Nav.Link>
                                    </Nav>
                                </Navbar.Collapse>
                            </Container>
                        </Navbar>
                    </header>

                    <main>
                        <Container className="mt-3">
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/projects" element={<Projects />} />
                            </Routes>
                        </Container>
                    </main>

                    <footer>
                        <Container>
                            <Row className="justify-content-between">
                                <Col md={4} className="mb-4 mb-md-0">
                                    <h6 className="text-success">Реквизиты</h6>
                                    <ul className="list-unstyled text-muted small">
                                        <li>ИНН: {config.inn}</li>
                                        <li>ОГРН: {config.ogrn}</li>
                                        <li>КПП: {config.kpp}</li>
                                        <li>ОКВЭД: {config.okved}</li>
                                    </ul>
                                </Col>
                                <Col md={4} className="mb-4 mb-md-0">
                                    <h6 className="text-success">Контакты</h6>
                                    <ul className="list-unstyled text-muted small">
                                        <li>Адрес: {config.companyAddress}</li>
                                        <li>Телефон: {config.companyPhone}</li>
                                        <li>Email: {config.companyEmail}</li>
                                    </ul>
                                </Col>
                            </Row>
                            <hr className="text-muted my-4" />
                            <Row>
                                <Col className="text-center">
                                    <small className="text-muted">
                                        &copy; {new Date().getFullYear()} {config.companyName}. Все права защищены.
                                    </small>
                                </Col>
                            </Row>
                        </Container>
                    </footer>
                </div>
            )}
        </Router>
    );
}

export default App;
